<template>
  <el-row>
    <el-col :span="12" class="left-container">
      <img src="../../../assets/images/register-bg.jpg"
           alt="积加ERP" class="register-bg-img"/>
    </el-col>
    <el-col :span="10"
            class="right-container">
      <img src="../../../assets/images/login_top.png" class="login-top-img"/>
      <img src="../../../assets/images/logo.png" class="logo-img"/>
      <app-phone-login></app-phone-login>
    </el-col>
  </el-row>
</template>

<script>
  import AppPhoneLogin from './components/phone-login'
  export default {
    components: { AppPhoneLogin},
    name: "AppLogin",
    data: function () {
      return {
        loginModel: 'phone',
        redirect: undefined,
        otherQuery: {}
      }
    }
  }
</script>

<style scoped>
  .left-container {
    height: 100vh;
    display: flex;
    align-items: center;
  }
  .right-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo-img--bg {
    position: absolute;
    width: 234px;
    top: 40px;
  }
  .logo-img,
  .login-top-img,
  .login-bottom-img {
    display: none;
  }
  .register-bg-img {
    /* width: 100%; */
    height: 100vh;
  }
  .logo-img--bg,
  .login-bg-big-img,
  .login-bg-small-img {
    margin-left: 100px;
  }
  >>> .login-form {
    width: 50%;
    min-width: 400px;
    text-align: center;
  }
  >>> .login-form .title {
    margin-bottom: 5px;
    font-size: 22px;
    color: #64a0ff;
  }
  >>> .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-radius: 0;
  }
  >>> .el-input__prefix {
    left: 0;
    font-size: 18px;
  }
  >>> .el-form-item {
    margin-bottom: 24px;
  }
  >>> .el-checkbox__label {
    color: #999;
  }
  >>> .el-checkbox__label:hover,
  >>> .el-checkbox__label:focus {
    color: #66b1ff;
  }

  @media (max-width: 1440px)  {
    .login-bg-big-img {
       display: none;
    }
    .login-bg-small-img {
      display: block;
    }
    .logo-img--bg {
      width: 200px;
    }
  }

  @media (min-width: 1441px)  {
    .login-bg-big-img {
      display: block;
    }
    .login-bg-small-img {
      display: none;
    }
    .logo-img--bg {
      width: 234px;
    }
  }
  @media (max-width: 864px) {
    .logo-img--bg {
      display: none;
    }
    .logo-img {
      display: block;
      width: 13rem;
      margin-bottom: 1.5rem;
    }
    .login-top-img,
    .login-bottom-img {
      display: block;
      width: 100%;
      height: 4.5rem;
    }
    .login-top-img {
      margin-bottom: 2rem;
    }
    .login-bottom-img {
      position: absolute;
      bottom: 0;
    }
    .left-container {
      display: none;
    }
    .right-container {
      width: 100%;
      flex-direction: column;
      justify-content: unset;
    }
    /deep/ .login-form {
      min-width: unset;
      width: 100%;
      padding: 0 1.5rem;
      box-sizing: border-box;
    }
    /deep/ .login-form .title {
      display: none;
    }
    /deep/ .el-form-item {
      margin-bottom: 16px;
    }
  }
</style>
